import TeamDirectoryPage from '../components/team/TeamDirectoryPage';

const Caregivers = () => {
    return (
        <TeamDirectoryPage
            title="Cuidadores e Pacientes"
            activeTab="Cuidadores e Pacientes"
            roleFilters={['PATIENT_CARE_GIVER']}
        />
    );
};

export default Caregivers;
